import React from "react";
import { Mail, Phone, MapPin, Leaf, Instagram, Linkedin, Twitter } from "lucide-react";
import { contact, eventInfo } from "../data/mock";

export default function Footer() {
  return (
    <footer className="relative bg-[#0f2a20] text-white pt-20 pb-8 overflow-hidden">
      <div className="absolute -top-32 -left-20 w-96 h-96 rounded-full bg-[#1F5943]/40 blur-3xl" />
      <div className="absolute -bottom-32 -right-20 w-96 h-96 rounded-full bg-[#2D7A5F]/30 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-10 mb-14">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center">
                <Leaf className="w-5 h-5 text-[#1F5943]" strokeWidth={2.5} />
              </div>
              <div>
                <div className="font-display text-2xl">multi-omix</div>
                <div className="text-[10px] tracking-[0.2em] text-white/60 font-semibold">
                  LIFE SCIENCES
                </div>
              </div>
            </div>
            <p className="text-white/70 leading-relaxed max-w-md mb-5">
              A movement to recognise laboratories reshaping science with a
              lighter footprint. Because there is only one Earth.
            </p>
            <div className="flex items-center gap-3">
              {[
                { Icon: Instagram, name: "instagram" },
                { Icon: Linkedin, name: "linkedin" },
                { Icon: Twitter, name: "twitter" },
              ].map(({ Icon, name }) => (
                <a
                  key={name}
                  href="#"
                  aria-label={name}
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg mb-4">Event</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>{eventInfo.date}</li>
              <li>{eventInfo.location}</li>
              <li>Venue: To be announced</li>
              <li><a href="#register" className="hover:text-white">Register &rarr;</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg mb-4">Contact</h4>
            <ul className="space-y-3 text-white/70 text-sm">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 text-[#4ADE80]" />
                <a href={`mailto:${contact.email}`} className="hover:text-white break-all">
                  {contact.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 text-[#4ADE80]" />
                <a href={`tel:${contact.phone}`} className="hover:text-white">
                  {contact.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-[#4ADE80]" />
                <span>Delhi NCR, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <div>
            &copy; 2026 Multi-Omix Sustainability Leader Awards. All rights reserved.
          </div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Code of Conduct</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
